module.exports = __webpack_public_path__ + "img/阻力带左腿拉伸.b6ca1d41.png";